module.exports = __webpack_public_path__ + "static/media/miles_hanging_guitars.b21f75b7.jpg";